<form class="row"
      novalidate
      [formGroup]="form"
      (keyup.enter)="submit()"
>
  <div class="col-12">
    <app-code-verifier [form]="code"></app-code-verifier>
  </div>
  <div class="col-12 mt-5">
    <button pButton
            class="p-button-md w-100"
            type="submit"
            label="VERIFY"
            [disabled]="form.invalid"
            (click)="submit()"
    ></button>
  </div>
  <div class="col-12">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <p class="mt-3">
        Back to
        <a class="p-link"
           routerLink="/auth/login"
        >
          Login page
        </a>
      </p>

      <p class="mt-3" style="display: none;">
        <a class="p-link"
           routerLink="/auth/registration-confirm"
        >
          Send a verification code via SMS
        </a>
      </p>
    </div>
  </div>
</form>
